import { Text } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { styles } from "./policy-identity.styles";

export function PolicyIdentityDetails({
  layout,
  reference,
  entries,
}: {
  readonly layout: "page" | "workspace" | undefined;
  readonly reference: string;
  readonly entries: readonly {
    readonly label: string;
    readonly value: string;
  }[];
}) {
  return (
    <details>
      <summary {...stylex.props(styles.summary)}>
        {layout === "workspace" ? "Identifiers and dates" : "Policy details"}
      </summary>
      {layout === "workspace" && (
        <p {...stylex.props(styles.reference)}>{reference}</p>
      )}
      <dl aria-label="Policy details" {...stylex.props(styles.details)}>
        {entries.map((entry) => (
          <div key={entry.label} {...stylex.props(styles.entry)}>
            <dt>
              <Text size="small" tone="muted">
                {entry.label}
              </Text>
            </dt>
            <dd {...stylex.props(styles.value)}>{entry.value}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
